/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_PARTIES_RECORDS_META_DATA,
  LOAD_PARTIES,
  CREATE_PARTIES,
  UPDATE_PARTIES,
  DELETE_PARTIES,
  LOAD_PARTIES_COLLECT,
  LOAD_PARTIES_PAY,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_CATEGORY,
  CREATE_PARTIES_CATEGORY,
  LOAD_PARTIES_LEDGER_STATEMENT,
  LOAD_STATE_LIST,
} from "./constants";

import {
  loadPartiesError,
  loadParties,
  loadPartiesSuccess,
  createPartiesListSuccess,
  createPartiesListError,
  updatePartiesListSuccess,
  updatePartiesListError,
  deletePartiesListSuccess,
  deletePartiesListError,
  loadPartiesRecordsMetaDataError,
  loadPartiesRecordsMetaDataSuccess,
  loadPartiesCollect,
  loadPartiesCollectSuccess,
  loadPartiesCollectError,
  loadPartiesPay,
  loadPartiesPaySuccess,
  loadPartiesPayError,
  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,
  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,
  loadLedgerStatmentList,
  loadLedgerStatmentListSuccess,
  loadLedgerStatmentListError,
  loadStateList,
  loadStateListSuccess,
  loadStateListError,
} from "./actions";

import {
  loadPartiesDetails,
  createPartiesDetails,
  updatePartiesDetails,
  deletePartiesDetails,
  loadRecordsMetaData,
  loadPartiesCollectDetails,
  loadPartiesPayDetails,
  loadPartiesTransactionDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadPartiesLedgerStatementDetails,
  loadStateDetails,
} from "./remotes";

function* loadPartiesSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadParties(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesDetails, partiesList);

        if (result) {
          yield put(loadPartiesSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadStateDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_STATE_LIST),
    });

    const { explicitLoad } = load;
    const { stateList } = explicitLoad || {};
    yield put(loadStateList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadStateDetails, stateList);

        if (result) {
          yield put(loadStateListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadStateListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesCollectSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_COLLECT),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadPartiesCollect(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesCollectDetails, partiesList);

        if (result) {
          yield put(loadPartiesCollectSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesCollectError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesPaySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_PAY),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadPartiesPay(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesPayDetails, partiesList);

        if (result) {
          yield put(loadPartiesPaySuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesPayError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadPartiesTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesTransactionDetails, partiesList);

        if (result) {
          yield put(loadPartiesTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesLedgerStatementSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_LEDGER_STATEMENT),
    });

    const { explicitLoad } = load;
    const { partiesList } = explicitLoad || {};
    yield put(loadLedgerStatmentList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartiesLedgerStatementDetails,
          partiesList
        );

        if (result) {
          yield put(loadLedgerStatmentListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadLedgerStatmentListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PARTIES),
    });

    const { partiesList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesDetails, partiesList);
        if (result) {
          yield put(createPartiesListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePartiesSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_PARTIES),
    });
    const { partiesList } = update || {};

    if (update) {
      try {
        const result = yield call(updatePartiesDetails, partiesList);
        if (result) {
          yield put(updatePartiesListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updatePartiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_PARTIES),
    });
    const { partiesList } = create || {};

    if (create) {
      try {
        const result = yield call(deletePartiesDetails, partiesList);
        if (result) {
          yield put(deletePartiesListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deletePartiesListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadPartiesCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesCategoryDetails, categoryList);

        if (result) {
          yield put(loadPartiesCategorySuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PARTIES_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesCategoryDetails, categoryList);
        if (result) {
          yield put(createPartiesCategoryListSuccess(result.data));
          console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartiesCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadItemRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_PARTIES_RECORDS_META_DATA),
    });

    try {
      const gstPercentage = yield call(loadRecordsMetaData, "getgst", "post");
      const state = yield call(loadRecordsMetaData, "getstate", "post");
      const currency = yield call(loadRecordsMetaData, "getcurrency", "post");

      let recordsMetaData = {
        gstPercentageOptions:
          (gstPercentage &&
            gstPercentage &&
            gstPercentage.length > 0 &&
            gstPercentage.map((c) =>
              Object.assign(
                {},
                {
                  label: c.gstpercentageName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        currencyOptions:
          (currency &&
            currency &&
            currency.length > 0 &&
            currency.map((c) =>
              Object.assign(
                {},
                {
                  label: c.currencyName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadPartiesRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadPartiesRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadPartiesSaga(),
    loadPartiesCollectSaga(),
    loadPartiesPaySaga(),
    deletePartiesSaga(),
    updatePartiesSaga(),
    createPartiesSaga(),
    loadItemRecordsMetaDataSaga(),
    loadPartiesTransactionSaga(),
    loadPartiesLedgerStatementSaga(),
    createPartiesCategorySaga(),
    loadPartiesCategorySaga(),
    loadStateDetailsSaga(),
  ]);
}
